import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import util from '../../util/util'
import '../../css/messages.scss'
import { useHistory } from 'react-router'

const MessageFilterList = (props) => {
  const history = useHistory()

  // var renderSurgeon = () => {
  //     return props.filters?.surgeon?.map((e,i) => {
  //         return(
  //             <Row key={i+1}>
  //                 : {util.getObj(props.surgeon, e).name}
  //             </Row>
  //         )
  //     })
  // }

  return props.filters && Object.keys(props.filters).length > 0 ? (
    <>
      <Row hidden={!props.filters?.receivedon} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Received On'}
        </Col>
        <Col span={8}>
          :
          {props.filters?.receivedon &&
            props.filters?.receivedon.min &&
            ' ' +
              util.getDateString(props.filters.receivedon.min) +
              ' - ' +
              util.getDateString(props.filters.receivedon.max)}
        </Col>
      </Row>
      <Row hidden={!props.filters?.phone} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Phone (last 4)'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.phone}</Col>
      </Row>
      <Row hidden={!props.filters?.deleted} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Show Deleted'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.deleted}</Col>
      </Row>
    </>
  ) : (
    <Row style={{ height: '100%' }} gutter={'10'}>
      <Col style={{ alignSelf: 'center' }} span={4}>
        {'No filters applied.'}
      </Col>
    </Row>
  )
}

MessageFilterList.propTypes = {
  customer: PropTypes.object,
  filters: PropTypes.object,
  surgeon: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    customer: state.profile.customer,
    filters: state.message?.filters,
    surgeon: state.surgeon.surgeons,
  }
}

export default connect(mapStateToProps, null)(MessageFilterList)
